import { useState, useMemo } from 'react';

// Hook pro sort state + seřazená data.
// Cycle: asc → desc → none.
// accessor(item) → hodnota pro řazení (default: item[key])

export default function useSortable(items, defaultKey = null, defaultDir = 'asc', accessor = null) {
  const [sortKey, setSortKey] = useState(defaultKey);
  const [sortDir, setSortDir] = useState(defaultDir);

  const sorted = useMemo(() => {
    if (!sortKey) return items;
    const getVal = accessor || ((item) => item[sortKey]);
    return [...items].sort((a, b) => {
      const av = getVal(a, sortKey);
      const bv = getVal(b, sortKey);
      // Null/undefined na konec bez ohledu na směr.
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      // Datum řetězce (ISO) — Date constructor parsuje ok, stringy také.
      let cmp;
      if (typeof av === 'number' && typeof bv === 'number') cmp = av - bv;
      else cmp = String(av).localeCompare(String(bv), 'cs', { numeric: true });
      return sortDir === 'asc' ? cmp : -cmp;
    });
  }, [items, sortKey, sortDir, accessor]);

  const toggleSort = (key) => {
    if (sortKey === key) {
      if (sortDir === 'asc') setSortDir('desc');
      else { setSortKey(null); setSortDir('asc'); }
    } else {
      setSortKey(key);
      setSortDir('asc');
    }
  };

  return { sorted, sortKey, sortDir, toggleSort };
}
